<template>
    <aside
        v-show="!isFormScreen"
        class="sidebar w-60 fixed top-0 z-40 h-screen bg-gray-800 transition-position left-0
    scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-gray-900 hover:scrollbar-thumb-gray-900"
        :class="[ isAsideMobileExpanded ? 'left-0' : '-left-60', isAsideLgActive ? 'block' : 'hidden xl:block' ]"
    >
        <div class="flex flex-row w-full bg-gray-900 text-white flex-1 h-14 items-center">
            <div class="flex-1 px-3">
                <BreezeApplicationLogo class="block h-9 w-auto text-white"/>
            </div>
        </div>
        <div>
            <template v-for="(menuGroup, index) in menu">
                <p v-if="typeof menuGroup === 'string'"
                   :key="`a-${index}`"
                   class="p-3 text-xs uppercase text-gray-400">
                    {{ menuGroup }}
                </p>
                <p v-else-if="typeof menuGroup.isTitle !== 'undefined' && UserCan(menuGroup.permissions)"
                   :key="`a-${index}`"
                   class="p-3 text-xs uppercase text-gray-400">
                    {{ menuGroup.label }}
                </p>
                <aside-menu-list
                    v-else
                    :key="`b-${index}`"
                    :menu="menuGroup"
                    @menu-click.prevent="menuClick"
                />
            </template>
        </div>
    </aside>
</template>

<script>
import {mdiMenu} from '@mdi/js'
import AsideMenuList from '@/Components/Dashboard/AsideMenuList'
import NavBarItem from '@/Components/Dashboard/NavBarItem'
import Icon from '@/Components/Dashboard/Icon'
import BreezeApplicationLogo from "@/Components/ApplicationLogo";

export default {
    name: 'AsideMenu',
    components: {AsideMenuList, NavBarItem, Icon, BreezeApplicationLogo},
    props: {
        menu: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        menuClick(event, item) {
            this.$inertia.visit(item.href || this.route(item.route))
        }
    },
    setup() {

        const isFormScreen = false;

        const isAsideMobileExpanded = true

        const isAsideLgActive = false

        return {
            isFormScreen,
            isAsideMobileExpanded,
            isAsideLgActive,
            mdiMenu
        }
    }
}
</script>
